import { render, staticRenderFns } from "./GoalSetup.vue?vue&type=template&id=1af57733&scoped=true&"
import script from "./GoalSetup.vue?vue&type=script&lang=js&"
export * from "./GoalSetup.vue?vue&type=script&lang=js&"
import style0 from "./GoalSetup.vue?vue&type=style&index=0&id=1af57733&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af57733",
  null
  
)

export default component.exports